// Copyright © 2021 Move Closer

import { Component, Prop, Vue } from 'vue-property-decorator'

import { BootstrapIcon } from '../../../dsl/front'
import dayjs, { Dayjs } from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import pl from 'dayjs/locale/pl'

@Component({
  name: 'PublicationDate',
  components: { BootstrapIcon },

  template: `
    <time v-if="value" class="publication-date" :class="{ 'publication-date--recent': isRecent }" :datetime="value">
      {{ isFuture ? $t('modules.tile.futureDate') : parsedDate }}
    </time>
  `
})
export class PublicationDate extends Vue {
  @Prop({ type: String, required: false, default: null })
  public readonly value!: string | null

  @Prop({ type: Boolean, required: false, default: false })
  private readonly shortenDate!: boolean

  public get date (): Dayjs {
    return dayjs(this.value || undefined)
  }

  public get now (): Dayjs {
    return dayjs()
  }

  public get isRecent (): boolean {
    return this.now.diff(this.date, 'hours') < 1
  }

  public get isFuture (): boolean {
    return this.date.isAfter(this.now)
  }

  public get parsedDate (): string {
    dayjs.extend(relativeTime)
    dayjs.locale(pl)

    if (!this.date.isValid()) {
      return ''
    }

    if (this.isRecent) {
      return this.date.fromNow()
    }

    const isToday = this.date.isSame(this.now, 'day')

    return this.date.format(isToday ? 'HH:mm' : (this.shortenDate ? 'DD.MM.YYYY' : 'D MMMM YYYY, HH:mm'))
  }
}
